import React, { useEffect, useState } from 'react';

import { Link, useLocation } from 'react-router-dom';
import { Divider, Menu } from 'antd';
import { UserOutlined, FileTextOutlined, IssuesCloseOutlined, PictureOutlined, CalendarOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const AdminNavbarContainer = () => {
	const { t } = useTranslation('page');

	const location = useLocation();

	interface NavbarItems {
		key: string;
		subkeys: string[];
	}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const navbarItems = [
		{
			key: 'admin/users',
			subkeys: ['admin-users-fallback', '/admin/users', '/admin/users/create'],
		},
		{
			key: 'admin/logs',
			subkeys: ['/admin/logs'],
		},
		{
			key: 'admin/maintenance-messages',
			subkeys: ['/admin/maintenance-messages'],
		},
		{
			key: 'admin/events',
			subkeys: ['admin-events-fallback', '/admin/events', '/admin/events/create'],
		},
		{
			key: 'admin/adverts',
			subkeys: ['admin-adverts-fallback', '/admin/adverts', '/admin/adverts/create'],
		},
	] as NavbarItems[];

	const [activeNavbarItemKey, setActiveNavbarItemKey] = useState('');
	const [activeSubKey, setActiveSubKey] = useState('');
	const [loading, setLoading] = useState(true);

	// ustawienie automatycznego mapowania ścieżki URL na rozwinięcie SubMenu oraz zaznaczenie Menu.Itema
	useEffect(() => {
		setLoading(true);
		const navbarItem = navbarItems.find((navbarItem) => location.pathname.includes(navbarItem.key));
		setActiveNavbarItemKey(navbarItem?.key || navbarItems[0].key);

		if (navbarItem) {
			const subKey = navbarItem.subkeys.find((subkey) => subkey.includes(location.pathname));
			if (subKey === undefined) {
				setActiveSubKey(navbarItem.subkeys[0]);
			} else {
				setActiveSubKey(subKey);
			}
		}
		setLoading(false);
	}, [navbarItems, location.pathname]);

	const usersSubMenu = (
		<Menu.SubMenu key={navbarItems[0].key} icon={<UserOutlined />} title={t('AdminPages.AdminLayout.Users')}>
			<Menu.Item key={navbarItems[0].subkeys[1]}>
				<Link to={navbarItems[0].subkeys[1]}>{t('AdminPages.AdminLayout.UserList')}</Link>
			</Menu.Item>
			<Menu.Item key={navbarItems[0].subkeys[2]}>
				<Link to={navbarItems[0].subkeys[2]}>{t('AdminPages.AdminLayout.AddUser')}</Link>
			</Menu.Item>
			<Menu.Item key={navbarItems[0].subkeys[0]} hidden />
		</Menu.SubMenu>
	);

	const eventsSubMenu = (
		<Menu.SubMenu key={navbarItems[3].key} icon={<CalendarOutlined />} title={t('AdminPages.AdminLayout.Events')}>
			<Menu.Item key={navbarItems[3].subkeys[1]}>
				<Link to={navbarItems[3].subkeys[1]}>{t('AdminPages.AdminLayout.EventList')}</Link>
			</Menu.Item>
			<Menu.Item key={navbarItems[3].subkeys[2]}>
				<Link to={navbarItems[3].subkeys[2]}>{t('AdminPages.AdminLayout.AddEvent')}</Link>
			</Menu.Item>
		</Menu.SubMenu>
	);

	const advertsSubMenu = (
		<Menu.SubMenu key={navbarItems[4].key} icon={<PictureOutlined />} title={t('AdminPages.AdminLayout.Adverts')}>
			<Menu.Item key={navbarItems[4].subkeys[1]}>
				<Link to={navbarItems[4].subkeys[1]}>{t('AdminPages.AdminLayout.AdvertList')}</Link>
			</Menu.Item>
			<Menu.Item key={navbarItems[4].subkeys[2]}>
				<Link to={navbarItems[4].subkeys[2]}>{t('AdminPages.AdminLayout.AddAdvert')}</Link>
			</Menu.Item>
		</Menu.SubMenu>
	);

	const logsSubMenu = (
		<Menu.SubMenu key={navbarItems[1].key} icon={<FileTextOutlined />} title={t('AdminPages.AdminLayout.Logs')}>
			<Menu.Item key={navbarItems[1].subkeys[0]}>
				<Link to={navbarItems[1].subkeys[0]}>{t('AdminPages.AdminLayout.LogList')}</Link>
			</Menu.Item>
		</Menu.SubMenu>
	);

	const maintenanceMessagesMenu = (
		<Menu.SubMenu
			key={navbarItems[2].key}
			icon={<IssuesCloseOutlined />}
			title={t('AdminPages.AdminLayout.MaintenanceMessages')}
		>
			<Menu.Item key={navbarItems[2].subkeys[0]}>
				<Link to={navbarItems[2].subkeys[0]}>{t('AdminPages.AdminLayout.MaintenanceMessagesList')}</Link>
			</Menu.Item>
		</Menu.SubMenu>
	);

	return (
		!loading && (
			<Menu className='h-100' defaultOpenKeys={[activeNavbarItemKey]} selectedKeys={[activeSubKey]} mode='inline'>
				{usersSubMenu}
				<Divider/>
				<Divider/>
				{eventsSubMenu}
				{advertsSubMenu}
				<Divider/>
				<Divider/>
				{logsSubMenu}
				{maintenanceMessagesMenu}
			</Menu>
		)
	);
};

export default AdminNavbarContainer;
